export default "__VITE_ASSET__Dju8v1R2__"